/**
 * First token of a display/full name (whitespace-separated). Useful for email salutations.
 */
export function firstNameFromFullName(fullName: string, fallback = 'friend'): string {
  const t = fullName.trim();
  if (!t) return fallback;
  const first = t.split(/\s+/)[0]?.trim() ?? '';
  return first || fallback;
}
